import { render, staticRenderFns } from "./ShippingListFiltersDrawer.vue?vue&type=template&id=179905c3"
import script from "./ShippingListFiltersDrawer.vue?vue&type=script&lang=js"
export * from "./ShippingListFiltersDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports